import { useState } from "react";
import PropTypes from "prop-types";
import { MisplacedBrokerModal } from "shared/Modal/MisplacedBrokerModal";
import { BrokerModalContainer } from "./BrokerModal.styles";
import SupportedBrokers from "shared/SupportedBrokers";
import { Loader } from "components/Loader";

const BrokerModal = ({
  show = true,
  onHide,
  handleBrokerClick,
  isConnecting = false,
}) => {
  const [showMisplacedBroker, setShowMisplacedBroker] = useState(false);

  const toggleMisplacedModal = () => {
    setShowMisplacedBroker(!showMisplacedBroker);
  };

  return (
    <>
      <BrokerModalContainer
        heading="Please Select Your Broker"
        className="broker-modal"
        headingClass="broker-modal-heading"
        show={show}
        onHide={onHide}
      >
        {isConnecting && <Loader className="mt-5" />}
        {!isConnecting && (
          <SupportedBrokers
            onBrokerSelect={handleBrokerClick}
            listHeight={335}
          />
        )}
      </BrokerModalContainer>
      <MisplacedBrokerModal
        show={showMisplacedBroker}
        onHide={toggleMisplacedModal}
      />
    </>
  );
};

export default BrokerModal;

BrokerModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  handleBrokerClick: PropTypes.func,
  isConnecting: PropTypes.bool,
};

BrokerModal.displayName = "BrokerModal";
